/**
 * Free Shipping Calculator
 *
 * This script calculates whether products qualify for free shipping based on
 * their CAD price equivalent, regardless of the display currency.
 *
 * The shipping threshold is $299 CAD for all markets due to Shopify checkout
 * limitations that require shipping rules to use the store's base currency.
 */

(function() {
  'use strict';

  // Wait for DOM and Shopify to be ready
  function initFreeShipping() {
    // Include Shopify's currency conversion script if not already loaded
    if (!window.Currency) {
      const script = document.createElement('script');
      script.src = '/services/javascripts/currencies.js';
      script.onload = function() {
        processFreeShipping();
      };
      document.head.appendChild(script);
    } else {
      processFreeShipping();
    }
  }

  function processFreeShipping() {
    const freeshipElements = document.querySelectorAll('.freeship[data-product-price]');

    freeshipElements.forEach(function(element) {
      const price = parseInt(element.dataset.productPrice);
      const currentCurrency = element.dataset.currentCurrency;
      const shopCurrency = element.dataset.shopCurrency;
      const thresholdCad = parseInt(element.dataset.thresholdCad);

      let qualifiesForFreeShipping = false;

      // If both shop and viewing currency are CAD, simple comparison
      if (currentCurrency === 'CAD' && shopCurrency === 'CAD') {
        qualifiesForFreeShipping = price >= thresholdCad;
      }
      // If viewing in USD but shop currency is CAD
      else if (currentCurrency === 'USD' && shopCurrency === 'CAD') {
        // Use Shopify's Currency converter if available
        if (window.Currency && window.Currency.convert) {
          // Convert the USD price back to CAD
          // The price is in cents, so divide by 100 for conversion
          const priceInDollars = price / 100;
          const thresholdInDollars = thresholdCad / 100;

          // Convert USD price to CAD
          try {
            const priceInCad = window.Currency.convert(priceInDollars, 'USD', 'CAD');
            qualifiesForFreeShipping = priceInCad >= thresholdInDollars;
          } catch (e) {
            // If conversion fails, check if we have the rate available
            if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
              // Shopify.currency.rate is the rate from base to current
              // So to convert back, we divide by the rate
              const priceInCad = price / window.Shopify.currency.rate;
              qualifiesForFreeShipping = priceInCad >= thresholdCad;
            }
          }
        }
        // Fallback: Use Shopify.currency.rate if available
        else if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
          // Convert USD price back to CAD
          const priceInCad = price / window.Shopify.currency.rate;
          qualifiesForFreeShipping = priceInCad >= thresholdCad;
        }
      }

      // Update the display based on qualification
      if (qualifiesForFreeShipping && !element.querySelector('svg')) {
        element.innerHTML = `
          <svg class="#icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
            <path d="M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM208 416c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm272 48c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"/>
          </svg>
          <span class="freeship-text">Free Shipping!</span>
        `;
      } else if (!qualifiesForFreeShipping && element.querySelector('svg')) {
        // Remove free shipping indicator if it doesn't qualify
        element.innerHTML = '';
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeShipping);
  } else {
    initFreeShipping();
  }

  // Re-run when products are dynamically loaded (e.g., infinite scroll)
  window.addEventListener('products:loaded', processFreeShipping);
})();